<template>
	<div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
		<confirm-copy-notification :show="copyNotificationVisible"></confirm-copy-notification>

		<div v-for="(template,index) in props.templates" :key="template.id" class="grid grid-cols-4 mb-12">
			<div class="flex items-center col-span-3">
				<div class="flex">
					<h3 class="text-gray-900 font-semibold">{{ template.formal_name }}</h3>
					<span class="flex-none uppercase bg-gray-200 text-gray-400 text-xs tracking-wide font-semibold px-2 py-1 rounded-md ml-3">
						PNG Preview
					</span>
				</div>
				<button @click="copyToClipboard(index)" class="bg-slides-blue bg-white flex flex-none items-center ml-auto mr-4 p-2 rounded shadow-sm text-white text-xs">
					<svg class="h-5 w-5 mr-2" viewBox="0 0 24 24" stroke-width="1.5" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M8.5 4H6C4.89543 4 4 4.89543 4 6V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V6C20 4.89543 19.1046 4 18 4H15.5" stroke="currentColor"  stroke-linecap="round"/>
						<path d="M8 6.4V4.5C8 4.22386 8.22386 4 8.5 4C8.77614 4 9.00422 3.77604 9.05152 3.50398C9.19968 2.65171 9.77399 1 12 1C14.226 1 14.8003 2.65171 14.9485 3.50398C14.9958 3.77604 15.2239 4 15.5 4C15.7761 4 16 4.22386 16 4.5V6.4C16 6.73137 15.7314 7 15.4 7H8.6C8.26863 7 8 6.73137 8 6.4Z" stroke="currentColor"  stroke-linecap="round"/>
					</svg>
					Copy to Clipboard
				</button>


			</div>
			<div class="border col-span-3 m-4 ml-0 shadow">
				<img :src="template.thumbnail_file_path" alt="" class="">
			</div>


		</div>





	</div>
</template>

<script>

import GalleryHeader from '@/Layouts/GalleryHeader'

export default {
	layout: GalleryHeader,
}
</script>
<script setup>

import ConfirmCopyNotification from "@/Components/ConfirmCopyNotification";

import {ref} from "vue";

const props = defineProps({
	templates: Object
})


const copyElement = ref('');
const copyNotificationVisible = ref(false);

document.addEventListener('copy', function(e){

	// only intercept if we're trying to copy something
	if(copyElement.value !== '') {

		// pull out the actual content we want from the json
		let element = copyElement.value['clipboard']['gslides'];

		// loop through it and add to the clipboard for each one
		for(const type in element) {
			e.clipboardData.setData(type, element[type]);
			console.log("added!");
		}

		e.preventDefault(); // default behaviour is to copy any selected text

		copyNotificationVisible.value = true;
		setTimeout(() => copyNotificationVisible.value = false, 6000)

		// now clear the copyElement so we're ready for the next copy
		copyElement.value = '';

	}
});

function copyToClipboard(index) {
	// set the selected icon to copyElement so we can use it later
	this.copyElement = props.templates[index];
	console.log(props.templates[index]);
	// console.log(classification,index);
	// console.log(groupedIcons.value[classification][index]);
	// this.copyElement = groupedIcons.value[classification][index];
	document.execCommand("copy");
}
</script>
